"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("isomorphic-fetch");
var _gql = _interopRequireDefault(require("../../../services/utils/gql"));
var _config = _interopRequireDefault(require("../../../consts/config"));
var _headers = require("../../../services/fetch/headers");
const updateLocaleMutation = (0, _gql.default)`
  mutation updateLocaleMutation($input: UpdateLocaleInput!) {
    updateLocale(input: $input) {
      __typename
    }
  }
`;
const updateLocale = async (token, input) => {
  var _response$data, _response$data$update;
  const variables = {
    input
  };
  const response = await fetch(`${_config.default.accountApiUrl}?operationName=updateLocale`, {
    method: "POST",
    headers: {
      ..._headers.JSON_BOTH,
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      query: updateLocaleMutation,
      variables
    })
  }).then(res => res.json());
  const isOk = ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$update = _response$data.updateLocale) === null || _response$data$update === void 0 ? void 0 : _response$data$update.__typename) === "UpdateLocalePayload";
  if (!isOk && response.errors) {
    return Promise.reject(new Error(response.errors.map(error => error.message).join(" & ")));
  }
  return true;
};
var _default = updateLocale;
exports.default = _default;